import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-clock-03',
	templateUrl: './icon-clock-03.component.svg',
})
export class IconClock03Component {}
